import React, { useRef } from "react";
import { Button } from "react-bootstrap";

/**
 * Lightweight rich-text-lite input for FAQ answers: a plain textarea plus
 * one "Insert Link" button that wraps the current text selection in a real
 * <a> tag. Deliberately not a full block editor (like EditorJsComponent) —
 * FAQ answers are a sentence or two, and stacking several full 400px+
 * document editors on one form for interlinking a word or two isn't worth
 * the weight. Value is stored/rendered as raw HTML.
 */
const FaqAnswerInput = ({ value, onChange, placeholder }) => {
  const textareaRef = useRef(null);

  const insertLink = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = (value || "").slice(start, end);

    const url = window.prompt("Link URL (e.g. https://www.bookwedgo.com/blogs/...):");
    if (!url) return;

    const linkText = selectedText || window.prompt("Link text:", "") || url;
    const linkHtml = `<a href="${url}" target="_blank" rel="noopener noreferrer">${linkText}</a>`;

    const nextValue = `${(value || "").slice(0, start)}${linkHtml}${(value || "").slice(end)}`;
    onChange(nextValue);

    // Restore focus with the cursor placed right after the inserted link.
    requestAnimationFrame(() => {
      textarea.focus();
      const cursorPos = start + linkHtml.length;
      textarea.setSelectionRange(cursorPos, cursorPos);
    });
  };

  return (
    <div>
      <div className="mb-2">
        <Button variant="outline-secondary" size="sm" onClick={insertLink} type="button">
          🔗 Insert Link
        </Button>
        <span className="text-muted ms-2" style={{ fontSize: 12 }}>
          Select a word or two, then click Insert Link to make it clickable.
        </span>
      </div>
      <textarea
        ref={textareaRef}
        className="form-control"
        rows={3}
        placeholder={placeholder}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && /<a[\s>]/i.test(value) && (
        <div
          className="mt-2 p-2 border rounded"
          style={{ fontSize: 13, color: "#555", background: "#fafafa" }}
        >
          <span className="text-muted d-block mb-1" style={{ fontSize: 11 }}>
            Preview:
          </span>
          <span dangerouslySetInnerHTML={{ __html: value }} />
        </div>
      )}
    </div>
  );
};

export default FaqAnswerInput;
